<template>



  <div>
    <b-form-group>
      <b-form-radio-group v-model="units" size="sm"
                          :options="[{ text: 'Miles', value: 'miles' },{ text: 'Km', value: 'km' }]" @change="calc">
      </b-form-radio-group>
    </b-form-group>
    <b-form-group>
      <b-form-radio-group id="metric" v-model="metric" size="sm"
                          :options="[{ text: 'Pace', value: 'pace' },{ text: 'Speed', value: 'speed' }]" @change="reset">
      </b-form-radio-group>
    </b-form-group>
    <!--      <p class="instruction">Enter distance and target time to get required pace:</p>-->

    <b-form-row>
      <b-col md="4" cols="6">
        <b-form-group v-if="metric=='pace'">
          <label for="pace">Pace  ({{(units=='miles'?' mins/mile':' mins/km')}})</label>
          <b-form-input id="pace" placeholder="mm:ss" v-model="pace" :state="validPace" :formatter="checkTimeInput"/>
          <small v-if="validPace==false">Enter pace as e.g. '9:05'</small>

        </b-form-group>
        <b-form-group v-else>
          <label for="speed">Speed ({{ units=='miles'?'mph':'km/h' }})</label>
          <b-form-input id="speed" placeholder="0" v-model="speed" type="text"
                        :state="validSpeed" :formatter="checkNumericInput"/>


        </b-form-group>
      </b-col>

    </b-form-row>
    <b-form-row>

      <b-col md="4" cols="6">
        <b-form-group>
          <label for="percentage">Percentage</label>
          <b-form-input id="time" ref="time" placeholder="%" v-model="percentage" :state="percentage && validPercentage" @input="calc"/>
          <small v-if="percentage && !validPercentage">E.g. 75, 105</small>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <div v-if="result" class="result mt-1">{{result}}
        </div>
      </b-col>
    </b-form-row>

  </div>

</template>
<script>

export default {
  data: () => ({
    units:"miles",
    metric: 'pace',
    pace:'',
    speed: '',
    percentage:100,
    result:''

  }),
  watch: {
    'pace': function () {
      this.calc();
    },
    'speed': function () {
      this.calc();
    },
    'percentage': function () {
      this.calc();
    }
  },

  activated() {
    if(sessionStorage.getItem('pace')){
      this.pace=sessionStorage.getItem('pace');
    }
    if(sessionStorage.getItem('units')){
      this.units=sessionStorage.getItem('units');
    }
    //console.log("PaceCalculator activated");
  },

  computed: {

    validSpeed() {
      if (!this.speed) return null;
      return /^\d{0,2}(?:[.]\d{1,3})?$/.test(this.speed);
    },
    validPace() {
      if (!this.pace) return null;
      return this.isValidPace(this.pace);
    },
    validPercentage() {
      if (!this.percentage) return null;
      const parsedValue = parseFloat(this.percentage);

      // 3. Check if the result is a valid number (not NaN) and is finite (excludes Infinity)
      if (!isNaN(parsedValue) && isFinite(parsedValue)) {
        return true;
      } else {
        return false;
      }

    },
  },
  mounted() {
    //HtmlDurationPicker.init();
  },
  methods: {
    inputsValid() {
      if(this.metric=='pace'){
        return this.pace && this.validPace && this.validPercentage;
      } else {
        return this.speed && this.validSpeed  && this.validPercentage;
      }

    },
    reset(){
      this.pace='';
      this.speed='';
      this.percentage=100;

    },

    calc () {
      //console.log("Calculate everything");

      if (this.inputsValid()) {
        console.log("inputs are valid, using metric "+this.metric)
        let speed
        let multiplier=this.percentage/100;
        if(this.metric=='pace') {
          speed=this.paceToMph(this.pace,false)/multiplier;
          this.result=this.mphToPace(speed,true)+(this.units == 'miles' ? ' mins/mile' : ' mins/km');
        } else {
          speed=this.round(this.speed*multiplier,2);
          this.result=speed+(this.units == 'miles' ? ' mph' : ' km/h');
        }

      } else {
        this.result="";
      }
    }
  }

}

</script>
<style type="text/scss" scoped>


</style>